// more here https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes#boolean_attributes

const dataAttribute = (condition: boolean | undefined) =>
  condition ? "" : undefined;

const ariaAttribute = (condition: boolean | undefined) =>
  condition ? true : undefined;

export { ariaAttribute, dataAttribute };
